import React, { useState, useRef, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const tkn = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const KOLONLAR = [
  { ad: 'Yıl',                             aciklama: 'Yıl — örn: 2026', zorunlu: true },
  { ad: 'Ay',                              aciklama: 'Ay numarası (1-12)', zorunlu: true },
  { ad: 'İŞLETME',                        aciklama: 'İşletme kodu (ALT, ANA, CEY, GOK, GOZ, KAR, KAZ, POL, SUL, TUR...)', zorunlu: true },
  { ad: 'Irk Adı',                         aciklama: 'Irk adı (SIYAH ALACA, ESMER, SIMENTAL, HEREFORD, JERSEY, SIYAH ANGUS...)', zorunlu: true },
  { ad: 'Boğa',                            aciklama: 'Erkek damızlık (boğa) sayısı', zorunlu: false },
  { ad: 'İnek',                            aciklama: 'Dişi damızlık (inek) sayısı', zorunlu: false },
  { ad: 'Genç Boğa',                       aciklama: 'Genç boğa sayısı', zorunlu: false },
  { ad: 'Düve',                            aciklama: 'Düve sayısı', zorunlu: false },
  { ad: 'Erkek Dana',                      aciklama: 'Erkek dana sayısı', zorunlu: false },
  { ad: 'Dişi Dana',                       aciklama: 'Dişi dana sayısı', zorunlu: false },
  { ad: 'Erkek Buzağı',                    aciklama: 'Erkek buzağı sayısı', zorunlu: false },
  { ad: 'Dişi Buzağı',                     aciklama: 'Dişi buzağı sayısı', zorunlu: false },
  { ad: 'Ticari Sığır (Besi-Kasaplık)',    aciklama: 'Besi/kasaplık amaçlı ticari sığır sayısı', zorunlu: false },
  { ad: 'Reforme Baş',                     aciklama: 'Reformasyona ayrılan hayvan sayısı', zorunlu: false },
];

export default function BuyukbasImport() {
  const [surukleUzeri, setSurukleUzeri] = useState(false);
  const [seciliDosya, setSeciliDosya] = useState<File | null>(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState<any>(null);
  const [hataModal, setHataModal] = useState(false);
  const [cakismaModal, setCakismaModal] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const sablonIndir = async () => {
    try {
      const res = await fetch(`${API}/api/hayvancilik/buyukbas/sablon`, { headers: tkn() });
      if (!res.ok) throw new Error('Sunucu hatası');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = 'buyukbas_sablon.xlsx'; a.click();
      URL.revokeObjectURL(url);
    } catch {
      alert('Şablon indirilemedi');
    }
  };

  const dosyaSec = (file: File) => {
    if (!file.name.match(/\.(xlsx|xls)$/i)) {
      alert('Lütfen .xlsx veya .xls dosyası seçin');
      return;
    }
    setSeciliDosya(file);
    setSonuc(null);
    setCakismaModal(false);
  };

  const onDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setSurukleUzeri(false);
    const file = e.dataTransfer.files[0];
    if (file) dosyaSec(file);
  }, []);

  const yukle = async (cakismaSecim: string = '') => {
    if (!seciliDosya) return;
    setYukleniyor(true);
    setCakismaModal(false);
    if (!cakismaSecim) setSonuc(null);
    try {
      const form = new FormData();
      form.append('file', seciliDosya);
      if (cakismaSecim) form.append('cakisma', cakismaSecim);
      const res = await axios.post(`${API}/api/hayvancilik/buyukbas/excel-import`, form, {
        headers: { ...tkn(), 'Content-Type': 'multipart/form-data' },
      });
      const data = res.data;
      if (data.bekliyor) {
        // Çakışma var — kullanıcıya sor
        setSonuc(data);
        setCakismaModal(true);
      } else {
        setSonuc(data);
      }
    } catch (e: any) {
      setSonuc({ hata: e.response?.data?.detail || 'Yükleme başarısız' });
    } finally {
      setYukleniyor(false);
    }
  };

  const temizle = () => {
    setSeciliDosya(null); setSonuc(null); setCakismaModal(false);
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <div style={{ padding: 28, maxWidth: 860, margin: '0 auto' }}>
      <h2 style={{ color: '#1a4a7a', marginBottom: 4 }}>🐄 Büyükbaş Excel Veri Yükleme</h2>
      <p style={{ color: '#666', fontSize: 14, marginBottom: 24 }}>
        Excel dosyasını sisteme yükleyin. Aynı işletme + dönem + ırk kombinasyonu varsa üzerine yazar.
      </p>

      {/* Kolon yapısı */}
      <div style={{ border: '1px solid #e0e0e0', borderRadius: 10, overflow: 'hidden', marginBottom: 24 }}>
        <div style={{ background: '#1a4a7a', color: '#fff', padding: '10px 16px', fontWeight: 600, fontSize: 14 }}>
          Kolon Yapısı (sıra önemlidir)
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f5f7fa' }}>
              <th style={{ padding: '8px 12px', textAlign: 'left', color: '#555', fontWeight: 600, width: 32 }}>#</th>
              <th style={{ padding: '8px 12px', textAlign: 'left', color: '#555', fontWeight: 600 }}>Kolon Adı</th>
              <th style={{ padding: '8px 12px', textAlign: 'left', color: '#555', fontWeight: 600 }}>Açıklama</th>
              <th style={{ padding: '8px 12px', textAlign: 'center', color: '#555', fontWeight: 600, width: 80 }}>Zorunlu</th>
            </tr>
          </thead>
          <tbody>
            {KOLONLAR.map((k, i) => (
              <tr key={i} style={{ borderTop: '1px solid #f0f0f0', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                <td style={{ padding: '7px 12px', color: '#999', fontWeight: 600 }}>{i + 1}</td>
                <td style={{ padding: '7px 12px', fontWeight: 600, color: '#222', fontFamily: 'monospace' }}>{k.ad}</td>
                <td style={{ padding: '7px 12px', color: '#555' }}>{k.aciklama}</td>
                <td style={{ padding: '7px 12px', textAlign: 'center' }}>
                  {k.zorunlu
                    ? <span style={{ background: '#fdecea', color: '#c0392b', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600 }}>Zorunlu</span>
                    : <span style={{ background: '#f0f0f0', color: '#888', padding: '2px 8px', borderRadius: 10, fontSize: 11 }}>Opsiyonel</span>
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ background: '#fffde7', padding: '10px 16px', fontSize: 12, color: '#7d6608', borderTop: '1px solid #f0e68c' }}>
          ⚠ Boş hücreler 0 olarak alınır. 1. satır başlık satırıdır, veri 2. satırdan başlar. "TOP/TOPLAM" satırı otomatik atlanır.
        </div>
      </div>

      {/* Yükleme alanı */}
      <div
        onDragOver={e => { e.preventDefault(); setSurukleUzeri(true); }}
        onDragLeave={() => setSurukleUzeri(false)}
        onDrop={onDrop}
        onClick={() => !seciliDosya && inputRef.current?.click()}
        style={{
          border: `2px dashed ${surukleUzeri ? '#1a4a7a' : seciliDosya ? '#27ae60' : '#ccc'}`,
          borderRadius: 12, padding: '32px 24px', textAlign: 'center',
          cursor: seciliDosya ? 'default' : 'pointer',
          background: surukleUzeri ? '#f0f7ff' : seciliDosya ? '#eafaf1' : '#fafafa',
          transition: 'all 0.15s', marginBottom: 16,
        }}>
        <input ref={inputRef} type="file" accept=".xlsx,.xls" style={{ display: 'none' }}
          onChange={e => { const f = e.target.files?.[0]; if (f) dosyaSec(f); }} />
        {seciliDosya ? (
          <div>
            <div style={{ fontSize: 36, marginBottom: 8 }}>📄</div>
            <div style={{ fontWeight: 600, color: '#1e8449', fontSize: 16 }}>{seciliDosya.name}</div>
            <div style={{ color: '#888', fontSize: 13, marginTop: 4 }}>{(seciliDosya.size / 1024).toFixed(1)} KB</div>
            <button onClick={e => { e.stopPropagation(); temizle(); }}
              style={{ marginTop: 12, background: 'none', border: '1px solid #ccc', borderRadius: 6, padding: '4px 14px', cursor: 'pointer', fontSize: 13, color: '#666' }}>
              × Dosyayı Kaldır
            </button>
          </div>
        ) : (
          <div>
            <div style={{ fontSize: 42, marginBottom: 10 }}>📂</div>
            <div style={{ fontWeight: 600, color: '#444', fontSize: 15 }}>Dosyayı buraya sürükleyin</div>
            <div style={{ color: '#888', fontSize: 13, marginTop: 6 }}>veya tıklayarak seçin</div>
            <div style={{ color: '#aaa', fontSize: 12, marginTop: 8 }}>.xlsx / .xls</div>
          </div>
        )}
      </div>

      {/* Butonlar */}
      {!sonuc?.basarili && !cakismaModal && (
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={sablonIndir}
            style={{ flex: 1, padding: '12px', background: '#fff', color: '#1a4a7a', border: '2px solid #1a4a7a', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
            ⬇ Şablon İndir
          </button>
          {seciliDosya && (
            <button onClick={() => yukle()} disabled={yukleniyor}
              style={{ flex: 2, padding: '12px', background: yukleniyor ? '#999' : '#1a4a7a', color: '#fff', border: 'none', borderRadius: 8, cursor: yukleniyor ? 'not-allowed' : 'pointer', fontWeight: 700, fontSize: 14 }}>
              {yukleniyor ? '⏳ Yükleniyor...' : '⬆ Sisteme Yükle'}
            </button>
          )}
        </div>
      )}

      {/* Çakışma Modalı */}
      {cakismaModal && sonuc?.bekliyor && (
        <div style={{ background: '#fff8e1', border: '2px solid #f9a825', borderRadius: 10, padding: 20, marginTop: 8 }}>
          <div style={{ fontWeight: 700, fontSize: 16, color: '#e65100', marginBottom: 12 }}>
            ⚠ Mevcut Kayıtlarla Çakışma
          </div>
          <div style={{ fontSize: 14, color: '#555', marginBottom: 8 }}>
            <strong>{sonuc.cakismalar?.length || 0}</strong> satır daha önce kaydedilmiş verilerle çakışıyor.
            {sonuc.yeni_sayisi > 0 && <> Ayrıca <strong>{sonuc.yeni_sayisi}</strong> yeni satır var.</>}
            {sonuc.hatali_sayisi > 0 && <> <strong style={{color:'#c0392b'}}>{sonuc.hatali_sayisi}</strong> satır hatalı.</>}
          </div>
          {sonuc.cakismalar && sonuc.cakismalar.length > 0 && (
            <div style={{ maxHeight: 150, overflowY: 'auto', background: '#fff', borderRadius: 6, border: '1px solid #e0e0e0', marginBottom: 12 }}>
              {sonuc.cakismalar.map((c: any, i: number) => (
                <div key={i} style={{ padding: '6px 12px', borderBottom: '1px solid #f0f0f0', fontSize: 13, color: '#666' }}>
                  Satır {c.satir}: {c.ozet}
                </div>
              ))}
            </div>
          )}
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={() => yukle('ustune_yaz')} disabled={yukleniyor}
              style={{ flex: 1, padding: '11px', background: '#e65100', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
              {yukleniyor ? '⏳...' : '✏ Üzerine Yaz'}
            </button>
            <button onClick={() => yukle('atla')} disabled={yukleniyor}
              style={{ flex: 1, padding: '11px', background: '#1a4a7a', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
              {yukleniyor ? '⏳...' : '⏭ Çakışanları Atla'}
            </button>
            <button onClick={temizle}
              style={{ padding: '11px 18px', background: '#f5f5f5', color: '#666', border: '1px solid #ddd', borderRadius: 7, cursor: 'pointer', fontSize: 14 }}>
              İptal
            </button>
          </div>
        </div>
      )}

      {/* Sonuç */}
      {sonuc && !sonuc.bekliyor && !sonuc.hata && sonuc.basarili !== undefined && (
        <div style={{ marginTop: 8 }}>
          <div style={{ background: '#eafaf1', border: '1px solid #a9dfbf', borderRadius: 8, padding: '16px 20px' }}>
            <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', alignItems: 'center' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#1e8449' }}>{sonuc.basarili}</div>
                <div style={{ fontSize: 13, color: '#555' }}>Başarılı Kayıt</div>
              </div>
              {sonuc.hatali_sayisi > 0 && (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 28, fontWeight: 700, color: '#c0392b' }}>{sonuc.hatali_sayisi}</div>
                  <div style={{ fontSize: 13, color: '#555' }}>Hatalı Satır</div>
                </div>
              )}
              {sonuc.hatali_sayisi > 0 && (
                <button onClick={() => setHataModal(true)}
                  style={{ marginLeft: 'auto', background: '#fdecea', color: '#c0392b', border: '1px solid #f5c6c6', borderRadius: 7, padding: '8px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
                  ⚠ Hataları Gör ({sonuc.hatali_sayisi})
                </button>
              )}
            </div>
            {sonuc.hatali_sayisi === 0 && (
              <div style={{ marginTop: 8, color: '#1e8449', fontWeight: 600 }}>✅ Tüm veriler başarıyla yüklendi.</div>
            )}
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
            <button onClick={temizle}
              style={{ flex: 1, padding: '10px', border: '1px solid #ddd', borderRadius: 7, background: '#f5f5f5', cursor: 'pointer', fontSize: 14 }}>
              Yeni Yükleme
            </button>
            <a href="/buyukbas"
              style={{ flex: 1, padding: '10px', background: '#1a4a7a', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 14, fontWeight: 600, textDecoration: 'none', textAlign: 'center', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
              Kayıtları Görüntüle →
            </a>
          </div>
        </div>
      )}

      {/* Hata sonucu */}
      {sonuc?.hata && (
        <div style={{ marginTop: 8, background: '#fdecea', border: '1px solid #f5c6c6', borderRadius: 8, padding: '16px 20px', color: '#c0392b' }}>
          <strong>❌ Hata:</strong> {sonuc.hata}
        </div>
      )}

      {/* Hata Detay Modal */}
      {hataModal && sonuc?.hatalar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setHataModal(false)}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, maxWidth: 600, width: '90%', maxHeight: '75vh', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div style={{ fontWeight: 700, fontSize: 16, color: '#c0392b' }}>
                ⚠ Hatalı Satırlar ({sonuc.hatali_sayisi})
              </div>
              <button onClick={() => setHataModal(false)}
                style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#999', lineHeight: 1 }}>×</button>
            </div>
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {sonuc.hatalar.map((h: string, i: number) => (
                <div key={i} style={{ padding: '8px 12px', borderBottom: '1px solid #fdecea', fontSize: 13, color: '#922b21', display: 'flex', gap: 10 }}>
                  <span style={{ color: '#c0392b', fontWeight: 700, minWidth: 20 }}>{i + 1}.</span>
                  <span>{h}</span>
                </div>
              ))}
            </div>
            <button onClick={() => setHataModal(false)}
              style={{ marginTop: 16, padding: '9px', background: '#f5f5f5', border: '1px solid #ddd', borderRadius: 7, cursor: 'pointer', fontSize: 14 }}>
              Kapat
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
